import { render, staticRenderFns } from "./DashboardConfiguration.vue?vue&type=template&id=c4213228&scoped=true&lang=pug&"
import script from "./DashboardConfiguration.vue?vue&type=script&lang=js&"
export * from "./DashboardConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DashboardConfiguration.vue?vue&type=style&index=0&id=c4213228&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4213228",
  null
  
)

export default component.exports